// Fallback only - each color from the API already carries its own admin-set
// `code` (Filament's ColorPicker on VehicleColor), which the swatch picker
// uses directly. This name -> hex guess only kicks in for a color that
// somehow has no code, and falls back further to a neutral gray for any
// name not listed here either.
const COLOR_NAME_TO_HEX = {
  black: "#202124",
  white: "#FFFFFF",
  silver: "#E0E0E0",
  gray: "#E0E0E0",
  grey: "#E0E0E0",
  red: "#EA0000",
  green: "#00881D",
  blue: "#0019BD",
  "dark blue": "#0019BD",
  navy: "#0019BD",
  "light blue": "#0DB6FE",
  "sky blue": "#0DB6FE",
  cyan: "#0DB6FE",
  orange: "#FF9D00",
  yellow: "#FFD400",
  gold: "#D4AF37",
  brown: "#7B4B27",
  beige: "#E8DCC5",
  tan: "#E8DCC5",
  purple: "#7A1FA2",
  pink: "#FF69B4",
  maroon: "#7A1F1F",
  bronze: "#8C6239",
};

const DEFAULT_SWATCH_COLOR = "#9AA0A6";

/*******************
@purpose : best-effort hex value for a color name so it can be drawn as a
           swatch - the API doesn't provide one
@Parameter : {name}
@Author : INIC
******************/
export const getSwatchColor = (name) =>
  COLOR_NAME_TO_HEX[(name || "").trim().toLowerCase()] || DEFAULT_SWATCH_COLOR;
